<template>
  <button
    @click="togglePlay"
    class="relative w-12 h-12 lg:w-18 lg:h-18 xl:w-24 xl:h-24 rounded-full bg-cw-green-alt transition-all duration-200 hover:scale-105 hover:opacity-90 active:scale-95 active:opacity-100"
  >
    <div class="absolute inset-0 flex justify-center gap-2 heightMd:gap-1 items-center">
      <div class="w-2.5 h-6 lg:w-4 lg:h-10 xl:w-5 xl:h-12 bg-[#85AD9E]"></div>
      <div class="w-2.5 h-6 lg:w-4 lg:h-10 xl:w-5 xl:h-12 bg-[#85AD9E]"></div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import { storeToRefs } from 'pinia'

const emit = defineEmits(['playGame', 'pauseGame'])
const { isPaused } = storeToRefs(useAppStore())

const togglePlay = () => {
  if (isPaused.value) {
    emit('playGame')
  } else {
    emit('pauseGame')
  }
  isPaused.value = !isPaused.value
}
</script>
